<template>
  <v-main>
  </v-main>
</template>

<script>
  export default {
    name: 'Logout',
    data: () => ({
    }),
    methods: {
      logout (){
        let self = this

        this.$http.secured.get('signout')
          .then(response => {
            this.$store.commit('unsetCurrentUser')
            self.$router.push({ name: 'login' })
          })
          .catch(error => {

          })
          .then(function () {
          })
      }
    },
    mounted() {
      this.logout()
    },
    components: {
    },
  }
</script>
